import { dateFormat } from '@blade/common/utils/filters';
import { PageOrderEnum } from '@blade-sxp/portrait-management/interfaces/common';
import { DbSyncInfoRequestUserTypeEnum, DbSyncInfoRequestStatusEnum } from '../interfaces/dbSync';
import { request } from '@blade/common';
const useLocal = false; // 使用本地
let list = [];
for (let i = 0; i < 20; i++) {
    if (useLocal)
        dbsyncAdd({ lib_ids: [1], user_type: DbSyncInfoRequestUserTypeEnum.BLACKLIST, device_id: '1' });
}
/** 新增下发库 */
export function dbsyncAdd(data) {
    if (!useLocal) {
        return request({
            url: `/api/access-management/api/v1/dbsync/add`,
            method: 'POST',
            data,
        });
    }
    return new Promise((resolve, reject) => {
        const result = {
            userType: data.user_type,
            libId: 1,
            libName: 'Portrait Library Name Too Long...',
            createBy: '1',
            createByName: 'lrf',
            updateTime: dateFormat(new Date(), 'yyyy-MM-DD HH:mm:ss') ?? '',
            createTime: dateFormat(new Date(), 'yyyy-MM-DD HH:mm:ss') ?? '',
            totalCount: 60,
            successCount: Math.random() > 0.5 ? 0 : 10,
            relationId: Math.random() * 100000000,
            failCount: Math.random() > 0.5 ? 0 : 50,
            status: Math.random() > 0.5 ? DbSyncInfoRequestStatusEnum.LOADED : DbSyncInfoRequestStatusEnum.UPLOADING
        };
        list.push(result);
        setTimeout(() => {
            resolve(result);
        }, 200);
    });
}
/** 下发库查询 */
export function dbsyncList(data) {
    if (!useLocal) {
        return request({
            url: `/api/access-management/api/v1/dbsync/list`,
            method: 'POST',
            data,
        });
    }
    return new Promise((resolve, reject) => {
        // 先过滤
        let tmp = list.filter(a => !data.libName || a.libName.includes(data.libName));
        if (data.userType)
            tmp = list.filter(a => a.userType === data.userType);
        // 再排序
        if (data.pageOrderList) {
            for (const orderList of data.pageOrderList) {
                if (orderList.orderField === 'updateTime') {
                    tmp = tmp.sort((a, b) => {
                        if (orderList.orderType === PageOrderEnum.ASC)
                            return +new Date(a.updateTime) - +new Date(b.updateTime);
                        return +new Date(b.updateTime) - +new Date(a.updateTime);
                    });
                }
            }
        }
        // 再分页
        const page = data.page ?? 1;
        const size = data.size ?? 10;
        const result = {
            page,
            size,
            total: tmp.length,
            totalPage: parseInt(tmp.length / size + '') + tmp.length % size > 0 ? 1 : 0,
            list: tmp.slice((page - 1) * size, page * size),
            empty: false
        };
        setTimeout(() => {
            resolve(result);
        }, 200);
    });
}
/** 删除人像库 */
export function dbsyncDelete(relationId) {
    if (!useLocal) {
        return request({
            url: `/api/access-management/api/v1/dbsync/${relationId}`,
            method: 'DELETE'
        });
    }
    return new Promise((resolve, reject) => {
        list = list.filter(a => String(a.relationId) !== relationId);
        setTimeout(() => {
            resolve(null);
        }, 200);
    });
}
/** 再次下发 */
export function dbsyncAgain(relationId) {
    if (!useLocal) {
        return request({
            url: `/api/access-management/api/v1/dbsync/again/${relationId}`,
            method: 'POST'
        });
    }
    return new Promise((resolve, reject) => {
        setTimeout(() => {
            resolve(null);
        }, 200);
    });
}
/** 下发库错误详情 */
export function dbsyncErrDetail(relationId) {
    if (!useLocal) {
        return request({
            url: `/api/access-management/api/v1/dbsync/${relationId}`,
            method: 'GET'
        });
    }
    return new Promise((resolve, reject) => {
        setTimeout(() => {
            resolve([
                {
                    portrait: 'https://t12.baidu.com/it/u=1604368823,2828015248&fm=58',
                    createTime: dateFormat(new Date(), 'yyyy-MM-DD HH:mm:ss') ?? '',
                    errorMsg: '不知道为什么'
                },
                {
                    portrait: 'https://t12.baidu.com/it/u=1604368823,2828015248&fm=58',
                    createTime: dateFormat(new Date(), 'yyyy-MM-DD HH:mm:ss') ?? '',
                    errorMsg: '不知道为什么'
                },
                {
                    portrait: 'https://t12.baidu.com/it/u=1604368823,2828015248&fm=58',
                    createTime: dateFormat(new Date(), 'yyyy-MM-DD HH:mm:ss') ?? '',
                    errorMsg: '不知道为什么'
                }
            ]);
        }, 200);
    });
}
